export default "__VITE_ASSET__DdgaYVvd__"